<template>
  <div class="password">
    <slot name="password-title"></slot>
    <!-- 登录-->
    <div class="title mb-8 tc">{{$t('login.password')}}</div>
    <el-form ref="passwordRef" :rules="rules" :model="formPwd" label-position="top" @keyup.enter.native="loginClick">
      <!-- 邮箱-->
      <el-form-item :label="$t('home.emailaddress')" prop="email">
        <el-input
            :placeholder="$t('home.emailaddress')" autocomplete="off"
            v-model.trim="formPwd.email"/>
      </el-form-item>
      <!-- 密码-->
      <el-form-item class="pass-input" :label="$t('login.password')" prop="password">
        <passwordInput v-model="formPwd.password" :placeholder="$t('login.password')"/>
        <div class="password-link">
          <!-- 忘记密码？-->
          <span class="green-text-2" @click="openForget">{{$t('login.forgotpassword')}}</span>
          <!-- 使用验证码登录-->
          <span class="green-text-2" @click="captchaLogin">{{$t('login.codelogin')}}</span>
        </div>
      </el-form-item>
      <!-- 登录-->
      <el-form-item>
        <el-button type="primary" :loading="submitLoading" @click="loginClick">{{$t('login.login')}}</el-button>
      </el-form-item>
    </el-form>
    <forgetPassword
        v-if="showForgetPassword"
        ref="forgetPassword"
        :email="formPwd.email"
        @closeForget="closeForget"/>
  </div>
</template>

<script>
import { isEmail, isPassword } from "@/util/validate"
import {
  login,
  getLoginCode
} from "@/request/requests";
import {
  MessageError,
  startLoading
} from "@/util/util"
import passwordInput from "@/components/passwordInput";
import forgetPassword from "./forgetPassword";
export default {
  name: "password",
  props:{
    email: String
  },
  components: {
    passwordInput,
    forgetPassword
  },
  data() {
    let validateEmail = (rules, value, cb) => {
      if (!isEmail(value)) {
        //请输入正确的邮箱格式
        return cb(new Error(this.$t('home.emailerror')));
      }
      return cb();
    };
    let validatePswLen = (rule, value, callback) => {
      if (!isPassword(value)) {
        callback(new Error(this.$t("login.validatepswlen")));
      } else {
        callback();
      }
    };
    return {
      showForgetPassword:false,
      submitLoading: false,
      formPwd: {
        email: '',
        password: ''
      },
      screenWidth:null,
      rules: {
        email: [
          {
            required: true,
            message: this.$t('home.pleaseenter') + ' ' + this.$t('home.emailaddress'),
            trigger: 'blur'
          },
          {
            required: true,
            validator: validateEmail,
            trigger: ['blur', 'change']
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('home.pleaseenter') + ' ' + this.$t('login.password'),
            trigger: 'blur'
          },
          // {
          //   validator: validatePswLen,
          //   trigger: 'blur'
          // },
        ]
      }
    }
  },
  watch: {
    email:{
      handler(newVal) {
        this.formPwd.email = newVal;
      },
      immediate: true
    }
  },
  methods: {
    loginClick() {
      this.$refs['passwordRef'].validate((valid) => {
        if(!valid) return;
        this.toLogin();
      })
    },
    async toLogin() {
      let loading = startLoading()
      let res = await login(this.formPwd)
      if (res.status == "200") {
        loading.close()
        await this.loginRes(res);
        //调接口 成功之后进到首页
        if (this.screenWidth > 576.98) {
          this.goPage('home');
        } else {
          this.goPage('phonehome');
        }
      } else {
        loading.close()
        MessageError(res.msg)
      }
      loading.close()
    },
    async loginRes(result) {
      let {
        userInfo,
        token,
        deadline
      } = result.data;
      this.$cookies.set("userInfo", JSON.stringify(userInfo), "7d");
      this.$cookies.set("token", token, "7d");
      this.$cookies.set("deadline", Date.parse(deadline), "7d");
      this.$notification.success({
        message: "Login successful",
        description: `Welcome back，${userInfo.email}`
      });
      // if (localStorage.lang == 'kr') {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLogin)
      // } else if (localStorage.lang == 'it') {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLoginIt)
      // } else if (localStorage.lang == 'ar') {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLoginAr)
      // } else if (localStorage.lang == 'fr') {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLoginFr)
      // } else {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLoginEn)
      // }
      // this.$router.push({
      //   name: "home"
      // });
    },
    calcWidth() {
      this.screenWidth = window.screen.width;
      this.$forceUpdate();
    },
    async captchaLogin(){
      let res = await getLoginCode(this.formPwd.email,1)
			console.log("TCL: captchaLogin -> res", res)
      this.$emit('captchaLogin')
    },
     closeForget(){
      this.showForgetPassword = false;
    },
    openForget(){
      this.showForgetPassword = true;
      this.$nextTick(()=>{
        this.$refs['forgetPassword'].init();
      })
    },
    goPage(page){
      this.$router.push({
        name: page
      })
    }

  },
  mounted() {
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/login.scss";
</style>